/**
 * Localização do sistema.
 */
export const LOCALIZACAO_SISTEMA = 'pt-BR';

export const TIMEZONE_SISTEMA = 'America/Fortaleza'

/**
 * Url do Backend.
 */
export const API_URL = import.meta.env.VITE_API_URL as string;

/**
 * Se deve exibir mensagens de log no console.
 */
export const SHOW_CONSOLE_LOG = import.meta.env.VITE_SHOW_CONSOLE_LOG as string;

/**
 * Chave secreta de permissões.
 */
export const SECRET_KEY_PERMISSOES = import.meta.env
  .VITE_SECRET_KEY_PERMISSOES as string;

/**
 * Id do token.
 */
export const TOKEN_KEY = '@defensor-token';

/**
 * Objeto com permissões do usuário.
 */
export const PERMISSOES_USUARIO = '@defensor-permissoes';

/**
 * Objeto de cache do lançamento de movimentos.
 */
export const CACHE_MOVIMENTOS = '@cache_edicao_movimentos';

/**
 * Cache dos filtros de movimentação.
 */
export const CACHE_MOVIMENTOS_FILTROS = '@cache_edicao_movimentos_filtros';

/**
 * Configurações do usuário logado.
 */
export const USUARIO_CONFIGS = 'runtime_user_configs';
